<template>
  <div v-if="item._id !== ''" :key="componentKey">
    <div class="flex items-center justify-center min-h-screen">
      <div class="bg-white p-8 shadow-lg w-full max-w-md">
        <h1 class="text-2xl font-bold mb-6 text-center text-gray-800">{{ this.item.nome }}</h1>
        <div class="flex flex-col items-center mb-6">
          <div class="flex space-x-4">
            <div class="flex flex-col items-center" v-if="this.item.status == false">
              <button @click="transmissao(false, '1')"
                class="border p-2 pl-3 pr-3 rounded-lg text-gray-700 hover:bg-gray-200 transition duration-300">
                <i class="fas fa-play"></i>
              </button>
              <span class="mt-2 text-gray-600">Start Stream</span>
            </div>
            <div class="flex flex-col items-center" v-if="this.item.status == true">
              <button @click="transmissao(false, '1')"
                class="border p-2 pl-3 pr-3 rounded-lg text-red-700 hover:bg-red-200 transition duration-300">
                <i class="fas fa-stop"></i>
              </button>
              <span class="mt-2 text-gray-600">Stop Stream</span>
            </div>
          </div>
        </div>
        <div class="mb-6">
          <p class="text-center font-bold mb-4 text-gray-400">Select input source</p>
          <div class="relative mb-4">
            <div @click="toggleDropdown('video')"
              class="dropdown-button w-full p-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition duration-300 cursor-pointer flex justify-between items-center">
              <span>{{
                item.dispositivoVideo == "false"
                  ? "Sem video"
                  : dispositivosVideoObj[item.dispositivoVideo].nome
              }}</span>
              <i class="fas fa-video text-white"></i>
            </div>
            <div v-if="dropdowns.video" class="dropdown-content absolute bg-white shadow-lg rounded-lg mt-2 w-full">
              <div v-for="(dispositivoVideo, keyDispositivoVideo) in item.dispositivosVideo" :key="keyDispositivoVideo"
                :item="dispositivoVideo" @click="selectOption('video', dispositivoVideo.id)"
                class="p-2 hover:bg-gray-200 cursor-pointer">
                {{ dispositivoVideo.nome }}
              </div>
            </div>
          </div>
          <div class="relative">
            <div @click="toggleDropdown('audio')"
              class="dropdown-button w-full p-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300 cursor-pointer flex justify-between items-center">
              <span>{{
                item.dispositivoAudio == "false"
                  ? "Sem áudio"
                  : dispositivosAudioObj[item.dispositivoAudio].nome
              }}</span>
              <i class="fas fa-volume-up text-white"></i>
            </div>
            <div v-if="dropdowns.audio" class="dropdown-content absolute bg-white shadow-lg rounded-lg mt-2 w-full">
              <div v-for="(
dispositivoAudio, keyDispositivoAudio
                ) in item.dispositivosAudio" :key="keyDispositivoAudio" :item="dispositivoAudio"
                @click="selectOption('audio', dispositivoAudio.id)" class="p-2 hover:bg-gray-200 cursor-pointer">
                {{ dispositivoAudio.nome }}</div>
            </div>
          </div>
        </div>
        <div class="flex justify-center">
          <div class="flex flex-col items-center w-1/4">
            <button @click="abrirEvento('1')"
              class="border p-2 pl-3 pr-3 rounded-lg text-gray-700 hover:bg-gray-200 transition duration-300">
              <i class="fas fa-video"></i>
            </button>
            <span class="mt-2 text-gray-600">Player</span>
          </div>
          <div class="flex flex-col items-center w-1/4">
            <button @click="permissaoDevices()"
              class="border p-2 pl-3 pr-3 rounded-lg text-gray-700 hover:bg-gray-200 transition duration-300">
              <i class="fas fa-cogs"></i>
            </button>
            <span class="mt-2 text-gray-600">Enabled</span>
          </div>
          <div class="flex flex-col items-center w-1/4">
            <button @click="novoCanal()"
              class="border p-2 pl-3 pr-3 rounded-lg text-gray-700 hover:bg-gray-200 transition duration-300">
              <i class="fas fa-history"></i>
            </button>
            <span class="mt-2 text-gray-600">Old</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { api } from "@/services/api.js";
import { apiOpenVidu } from "@/services/apiOpenVidu.js";
import { apiFlashphoner } from "@/services/apiFlashphoner.js";
import { apiMS } from "@/services/apiMS.js";
import util from "../includes/util.js";

export default {
  name: "TransmitEvento",
  components: {},
  props: {
    propView: { type: String, default: "modal" },
    propColunas: {
      type: Array,
      default: function () {
        return ["col-md-12", "text-center"];
      },
    },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    permissaoDevices() {
      window.navigator.mediaDevices
        .getUserMedia({ audio: true, video: true })
        .then(() => {
          //window.navigator.mediaDevices.getUserMedia();
          window.document.location.reload();
        });
    },
    async carregarItemUpdate(id) {
      const response = await api.get("/evento/" + id);

      //* Verifica se econtrou
      if (response.data.itens.length > 0) {
        let itemEdit = response.data.itens[0];

        this.item.nome = itemEdit.nome;
        this.item.servidor = itemEdit.servidor;
        this.item.situacao = itemEdit.situacao;
        this.item.canais = itemEdit.canais;
      }

      var thisCall = this;

      setTimeout(function () {
        try {
          thisCall.carregarItemUpdate(id);
        } catch (err) {
          console.error(err);
        }
      }, 5000);
    },
    async carregarItem(id) {
      //* Limpa os campos
      this.novo();

      //* Carrega os dados
      var itemEdit = {};

      const response = await api.get("/evento/" + id);

      //* Verifica se econtrou
      if (response.data.itens.length > 0) {
        itemEdit = response.data.itens[0];

        this.item._id = itemEdit._id;
        this.item.nome = itemEdit.nome;
        this.item.servidor = itemEdit.servidor;
        this.item.situacao = itemEdit.situacao;
        this.item.canais = itemEdit.canais;
        this.item.servidorTipo = itemEdit.servidorTipo
          ? itemEdit.servidorTipo
          : "openvidu";
        this.item.linkFonte = itemEdit.linkFonte;
        this.item.status = false;
        this.item.canal = "1";
        this.item.canalTransmissao = "";
        this.item.cropTopo = "0";
        this.item.cropRodape = "0";
        this.item.cropEsquerda = "0";
        this.item.cropDireita = "0";
        this.item.cropTopoLive = "0";
        this.item.cropRodapeLive = "0";
        this.item.cropEsquerdaLive = "0";
        this.item.cropDireitaLive = "0";
        this.item.dispositivoVideo = "screen";
        this.item.dispositivoAudio = "false";

        this.item.eventoRemoto = "";
        this.item.eventosRemoto = [];

        if (
          this.retornaSite() == "7live" &&
          this.item.dispositivosAudio.length > 1
        ) {
          this.item.dispositivoAudio = this.item.dispositivosAudio[1]["id"];
        }

        for (var indiceCanal = 0; indiceCanal <= 20; indiceCanal++) {
          //* Define como padrao o canal definido no evento
          this.canais[indiceCanal.toString()] = {
            canal: indiceCanal.toString(),
            servidor: this.item.servidorTipo + "_" + this.item.servidor,
            status: false,
            enabled:
              this.item.servidorTipo == "ms" && indiceCanal > 1 ? false : true,
          };

          if (this.retornaSite() !== "7live" && itemEdit.transmissaoCanais) {
            if (itemEdit.transmissaoCanais[indiceCanal.toString()]) {
              if (itemEdit.transmissaoCanais[indiceCanal.toString()].servidor) {
                var servidorTransmissao = this.$global
                  .servidores_sip_array()
                  .filter(function (item) {
                    return (
                      item.id ==
                      itemEdit.transmissaoCanais[indiceCanal.toString()]
                        .servidor && item.id.startsWith(itemEdit.servidorTipo)
                    );
                  });

                if (servidorTransmissao.length > 0) {
                  this.canais[indiceCanal.toString()].servidor =
                    itemEdit.transmissaoCanais[indiceCanal.toString()].servidor;
                }
              }
            }
          }
        }

        if (this.item.servidorTipo == "sh") {
          apiFlashphoner.initStream();
        }

        if (
          this.retornaSite() == "Share" ||
          this.retornaSite() == "7live" ||
          this.item.servidorTipo == "ms2"
        ) {
          this.viewPreview = "not-preview";
        }

        document.title = "TR: " + itemEdit.nome;

        this.carregarItemUpdate(itemEdit._id);
      }
    },
    async carregarEventosRemoto() {
      const response = await api.get("/evento/remoto");
      this.$set(this.item, "eventosRemoto", response.data.itens);
    },
    async novo() {
      this.$set(this.item, "_id", "");
      this.$set(this.item, "nome", "");
      this.$set(this.item, "servidor", "");
      this.$set(this.item, "servidorTipo", "");
      this.$set(this.item, "situacao", "");
      this.$set(this.item, "canais", "");
      this.$set(this.item, "rtmpLink", "-");
      this.$set(this.item, "rtmpChave", "-");
      this.$set(this.item, "linkFonte", "");
      this.$set(this.item, "ovToken", "");
      this.$set(this.item, "status", false);
      this.$set(this.item, "canal", "1");
      this.$set(this.item, "canalPrincipal", "");
      this.$set(this.item, "canalTransmissao", "0");
      this.$set(this.item, "cropTopo", "0");
      this.$set(this.item, "cropRodape", "0");
      this.$set(this.item, "cropEsquerda", "0");
      this.$set(this.item, "cropDireita", "0");
      this.$set(this.item, "cropTopoLive", "0");
      this.$set(this.item, "cropRodapeLive", "0");
      this.$set(this.item, "cropEsquerdaLive", "0");
      this.$set(this.item, "cropDireitaLive", "0");
      this.$set(this.item, "dispositivoVideo", "screen");
      this.$set(this.item, "dispositivoAudio", "false");
      this.$set(this.item, "eventoRemoto", "");
      this.$set(this.item, "eventosRemoto", []);
    },
    async transmissao(videoFiltro, canal) {
      var response;

      var itemEdit = {};

      var replyTo = [];

      if (
        this.$global.servidores_sip()[
          this.item.servidorTipo + "_" + this.item.servidor
        ].replyTo.length > 0
      ) {
        canal = "0";
        replyTo =
          this.$global.servidores_sip()[
            this.item.servidorTipo + "_" + this.item.servidor
          ].replyTo;
      }

      canal = canal.toString();

      //* Verifica se vai iniciar uma nova transmissao
      if (this.item.status == false) {
        var defineCanaisEvento;

        if (this.retornaSite() == "7live") {
          defineCanaisEvento =
            replyTo.length > 0 ? "&canais=" + replyTo.length : "&canais=1";
        }

        var servidorProps = this.$global.servidores_sip()[
          this.item.servidorTipo + "_" + this.item.servidor
        ]
          ? this.$global.servidores_sip()[
          this.item.servidorTipo + "_" + this.item.servidor
          ]
          : null;

        response = await api.get(
          "/evento/transmit/" +
          this.item._id +
          "?canal=" +
          canal +
          "&servidorTag=" +
          (servidorProps !== null && servidorProps.tag
            ? servidorProps.tag
            : "") +
          "&servidorLimite=" +
          (servidorProps !== null && servidorProps.limite
            ? servidorProps.limite
            : 100) +
          defineCanaisEvento +
          //(canalServidor ? "&canalServidor=" + canalServidor : "") +
          (videoFiltro ? "&videoFiltro=true" : "")
        );

        //* Verifica se econtrou
        if (response.data.itens.length > 0) {
          itemEdit = response.data.itens[0];
        }
      }

      //* Verifica o tipo de servidor
      if (this.item.servidorTipo == "openvidu") {
        if (this.item.status == false) {
          //* Verifica se econtrou
          if (itemEdit.ovToken) {
            this.item.ovToken = itemEdit.ovToken;
            apiOpenVidu.entrarSessaoA(
              this.item.ovToken,
              this.item.dispositivoVideo,
              this.item.dispositivoAudio,
              canal
            );
          }
        } else {
          apiOpenVidu.fecharSessao(canal);
        }
      } else if (this.item.servidorTipo == "ant") {
        if (this.item.status == false) {
          var idCanal = itemEdit["_id"] + "_" + canal;

          console.log(itemEdit);

          if (
            itemEdit.logAnt[idCanal] &&
            itemEdit.logAnt[idCanal].publishTokenId
          ) {
            var arrServidor = itemEdit.servidor.split(":");

            this.$set(
              this.item,
              "rtmpLink",
              "rtmp:" + arrServidor[1] + "/WebRTCAppEE/"
            );
            this.$set(
              this.item,
              "rtmpChave",
              idCanal + "?token=" + itemEdit.logAnt[idCanal].publishTokenId
            );
          }
        }
      } else if (this.item.servidorTipo == "sh") {
        console.log("sh");
      } else if (this.item.servidorTipo == "ms") {
        if (this.item.status == false) {
          apiMS.setTipo("produtor");
          apiMS.setUrl(itemEdit.servidor);
          apiMS.setToken(itemEdit.msToken);
          apiMS.connect({});

          if (replyTo.length > 0) {
            for (
              var indiceReply = 0;
              indiceReply < replyTo.length;
              indiceReply++
            ) {
              var instaceDestServidor =
                replyTo[indiceReply].instanceDest.split("_");

              var servidorRouterProps = this.$global.servidores_sip()[
                instaceDestServidor
              ]
                ? this.$global.servidores_sip()[instaceDestServidor]
                : null;

              await api.get(
                "/evento/transmit/" +
                this.item._id +
                "?canal=" +
                replyTo[indiceReply].canal +
                "&servidor=" +
                encodeURI(replyTo[indiceReply].instanceDest) +
                "&servidorTag=" +
                (servidorRouterProps !== null && servidorRouterProps.tag
                  ? servidorRouterProps.tag
                  : "") +
                "&servidorLimite=" +
                (servidorRouterProps !== null && servidorRouterProps.limite
                  ? servidorRouterProps.limite
                  : 100) +
                (videoFiltro ? "&videoFiltro=true" : "")
              );

              replyTo[indiceReply].instanceDest = instaceDestServidor[1];
              replyTo[indiceReply].salaDest =
                this.item._id + "_" + replyTo[indiceReply].canal;
            }

            apiMS.setRoutes(replyTo);
          }

          this.msPublicar();
        } else {
          apiMS.closeProducer(this.item._id + "_" + canal);
          apiMS.disconnect();
        }
      }

      this.$set(this.item, "status", !this.item.status);
    },
    msPublicar() {
      if (apiMS.getConectado()) {
        apiMS.publish(
          this.item.dispositivoVideo,
          this.item.dispositivoAudio,
          this.viewPreview == "preview"
        );
      } else {
        var thisCall = this;
        setTimeout(function () {
          thisCall.msPublicar();
        }, 1000);
      }
    },
    msPublicarRemoto(instanceDest, salaDest, servidorFonte, eventoFonte) {
      if (apiMS.getConectado()) {
        apiMS.publishRouteRemoteReplication(
          instanceDest,
          salaDest,
          servidorFonte,
          eventoFonte
        );
      } else {
        var thisCall = this;
        setTimeout(function () {
          thisCall.msPublicarRemoto(
            instanceDest,
            salaDest,
            servidorFonte,
            eventoFonte
          );
        }, 1000);
      }
    },
    async transmissaoCanais(videoFiltro, canal) {
      if (
        this.selecaoCanais.tipo == "status" &&
        this.selecaoCanais.itens[canal]
      ) {
        let arrKeys = Object.keys(this.selecaoCanais.itens);

        for (let indexKey = 0; indexKey < arrKeys.length; indexKey++) {
          await this.transmissaoCanal(videoFiltro, arrKeys[indexKey]);
        }

        this.selecionarCanalLimpar();
      } else {
        this.transmissaoCanal(videoFiltro, canal);
      }
    },
    async transmissaoCanal(videoFiltro, canal) {
      var response;

      var itemEdit = {};

      //* Carrega os dados do servidor
      var servidor = this.canais[canal].servidor.split("_");
      var servidorProps = this.$global.servidores_sip()[
        this.canais[canal].servidor
      ]
        ? this.$global.servidores_sip()[this.canais[canal].servidor]
        : null;

      //* Verifica se vai iniciar uma nova transmissao
      if (this.canais[canal].status == false) {
        response = await api.get(
          "/evento/transmit/" +
          this.item._id +
          "?servidor=" +
          encodeURI(this.canais[canal].servidor) +
          "&servidorTag=" +
          (servidorProps !== null && servidorProps.tag
            ? servidorProps.tag
            : "") +
          "&servidorLimite=" +
          (servidorProps !== null && servidorProps.limite
            ? servidorProps.limite
            : 100) +
          "&canal=" +
          canal +
          (videoFiltro ? "&videoFiltro=true" : "")
        );

        //* Verifica se econtrou
        if (response.data.itens.length > 0) {
          itemEdit = response.data.itens[0];
        }
      }

      //* Verifica o tipo de servidor
      if (servidor[0] == "openvidu") {
        if (this.canais[canal].status == false) {
          //* Verifica se econtrou
          if (itemEdit.ovToken) {
            apiOpenVidu.entrarSessaoA(
              itemEdit.ovToken,
              this.item.dispositivoVideo,
              this.item.dispositivoAudio,
              canal
            );
            this.canais[canal].status = true;
            this.$forceUpdate();
          }
        } else {
          apiOpenVidu.fecharSessao(canal);
          this.canais[canal].status = false;
          this.$forceUpdate();
        }
      } else if (servidor[0] == "sh") {
        if (this.canais[canal].status == false) {
          apiFlashphoner.connectPublish(
            localStorage.getItem("ckd"),
            this.item,
            canal,
            this.item.dispositivoVideo,
            this.viewPreview == "preview"
          );
          this.canais[canal].status = true;
          this.$forceUpdate();
        } else {
          apiFlashphoner.stopStream(this.item, canal);
          this.canais[canal].status = false;
          this.$forceUpdate();
        }
      } else if (this.item.servidorTipo == "ms") {
        if (this.canais[canal].status == false) {
          var arrServidor = this.canais[canal].servidor.split("_");

          if (this.item.canalPrincipal == "") {
            this.item.canalPrincipal = canal;

            for (var keyCanal in this.canais) {
              this.canais[keyCanal].enabled = true;
            }

            if (this.item.canalPrincipal == "1") {
              this.canais["0"].enabled = false;
            }

            if (this.item.dispositivoVideo == "sharescreen") {
              apiMS.setTipo("produtor-remoto");
              apiMS.setUrl(arrServidor[1]);
              apiMS.setToken(itemEdit.msToken);
              apiMS.connect({});
            } else {
              apiMS.setTipo("produtor");
              apiMS.setUrl(arrServidor[1]);
              apiMS.setToken(itemEdit.msToken);
              apiMS.connect({});
              this.msPublicar();
            }
          } else {
            apiMS.publishRouteReplication(
              arrServidor[1],
              this.item._id + "_" + canal
            );
          }

          if (this.item.dispositivoVideo == "sharescreen") {
            //* Atualiza a lista de eventos remotos
            await this.carregarEventosRemoto();

            //* Percorre os eventos para verificar se ainda consta o selecionado
            var eventoRemoto = null;

            for (
              var indiceEventoRemoto = 0;
              indiceEventoRemoto < this.item.eventosRemoto.length;
              indiceEventoRemoto++
            ) {
              eventoRemoto = this.item.eventosRemoto[indiceEventoRemoto];

              if (eventoRemoto._id == this.item.eventoRemoto) {
                break;
              } else {
                eventoRemoto = null;
              }
            }

            //* Caso o evento ainda exista, envia o comando para replicar para o canal
            if (eventoRemoto !== null) {
              this.msPublicarRemoto(
                arrServidor[1],
                this.item._id + "_" + canal,
                eventoRemoto.servidor,
                this.item.eventoRemoto
              );
            } else {
              return;
            }
          }

          this.canais[canal].status = !this.canais[canal].status;
        } else {
          if (this.item.canalPrincipal == canal) {
            this.item.canalPrincipal = "";
            apiMS.closeProducer(this.item._id + "_" + canal);
            apiMS.disconnect();

            Object.entries(this.canais).forEach(([keyCanal]) => {
              this.canais[keyCanal].status = false;
              if (parseInt(keyCanal) > 1) {
                this.canais[keyCanal].enabled = false;
              } else {
                this.canais[keyCanal].enabled = true;
              }
            });
          } else {
            apiMS.closeProducer(this.item._id + "_" + canal);
            this.canais[canal].status = !this.canais[canal].status;
          }
        }

        this.$forceUpdate();
      }
    },
    async rtmp() {
      var itemEdit = {};

      this.$set(this.item, "rtmpLink", "-");
      this.$set(this.item, "rtmpChave", "-");

      var response = await api.get(
        "/evento/transmit/" + this.item._id + "?canal=" + this.item.canal
      );

      //* Verifica se econtrou
      if (response.data.itens.length > 0) {
        itemEdit = response.data.itens[0];

        var idCanal = itemEdit["_id"] + "_" + this.item.canal;

        if (
          itemEdit.logAnt[idCanal] &&
          itemEdit.logAnt[idCanal].publishTokenId
        ) {
          var arrServidor = itemEdit.servidor.split(":");

          this.$set(
            this.item,
            "rtmpLink",
            "rtmp:" + arrServidor[1] + "/WebRTCAppEE/"
          );
          this.$set(
            this.item,
            "rtmpChave",
            idCanal + "?token=" + itemEdit.logAnt[idCanal].publishTokenId
          );
        }
      }
    },
    async crop() {
      /*
      if (videoFiltro) {
        publishConfig["filter"] = {
          type: "GStreamerFilter",
          options: {
            command: "videocrop top=50 right=0 bottom=0",
          },
        };
      }*/

      /*
      apiOpenVidu.getPublisher().stream.applyFilter("FaceOverlayFilter").then(filter => {
          filter.execMethod(
              "setOverlayedImage",
              {
                  "uri":"https://cdn.pixabay.com/photo/2013/07/12/14/14/derby-148046_960_720.png",
                  "offsetXPercent":"-0.2F",
                  "offsetYPercent":"-0.8F",
                  "widthPercent":"10.3F",
                  "heightPercent":"10.0F"
              });
      });*/

      apiOpenVidu.getPublisher().stream.removeFilter();

      apiOpenVidu
        .getPublisher()
        .stream.applyFilter("GStreamerFilter", {
          command:
            "videocrop top=" +
            this.item.cropTopo +
            " bottom=" +
            this.item.cropRodape +
            " left=" +
            this.item.cropEsquerda +
            " right=" +
            this.item.cropDireita,
        })
        .then(() => {
          console.log("Video crop!");
        })
        .catch((error) => {
          console.error(error);
        });

      /*

        apiOpenVidu
        .getPublisher()
        .stream.applyFilter("GStreamerFilter", {
          command:
            "textoverlay text=\"Embedded text\" valignment=top halignment=right font-desc=\"Cantarell 25\"",
        })
        .then(() => {
          console.log("Video crop!");
        })
        .catch((error) => {
          console.error(error);
        });*/
    },
    novoCanal() {
      window.open(
        "/live/" + this.item._id + "?old",
        "newwindow_" + Date.now(),
        "scrollbars=1,width=584,height=750",
        true
      );
    },
    abrirFonte() {
      window.open(
        this.item.linkFonte,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=450,height=500",
        true
      );
    },
    abrirEvento(canal) {
      window.open(
        "/view/" + this.item._id + "?view=clean&canal=" + canal,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=450,height=500",
        true
      );
    },
    definirCompartilhamento() {
      this.item.previewAberto = true;
      apiOpenVidu.definirCompartilhamento(this.item.dispositivoVideo);
    },
    livePreview() {
      this.item.cropTopoLive = this.item.cropTopo;
      this.item.cropRodapeLive = this.item.cropRodape;
      this.item.cropEsquerdaLive = this.item.cropEsquerda;
      this.item.cropDireitaLive = this.item.cropDireita;
      apiOpenVidu.livePreview();
      this.item.abaTransmissaoVideo = "live";
      this.item.tabLive = true;
    },
    abaTransmissaoVideo(novaAba) {
      this.item.abaTransmissaoVideo = novaAba;
    },
    cropPreview(clear = false) {
      if (clear) {
        this.item.cropTopo = 0;
        this.item.cropRodape = 0;
        this.item.cropEsquerda = 0;
        this.item.cropDireita = 0;
      }

      apiOpenVidu.cropPreview(
        this.item.cropTopo,
        this.item.cropRodape,
        this.item.cropEsquerda,
        this.item.cropDireita
      );
    },
    cropLive(clear = false) {
      if (clear) {
        this.item.cropTopoLive = 0;
        this.item.cropRodapeLive = 0;
        this.item.cropEsquerdaLive = 0;
        this.item.cropDireitaLive = 0;
      }

      apiOpenVidu.cropLive(
        this.item.cropTopoLive,
        this.item.cropRodapeLive,
        this.item.cropEsquerdaLive,
        this.item.cropDireitaLive
      );
    },
    editarCanal(canal) {
      this.canalEdicao = canal;
      window.$("#modalCanal").modal("show");
    },
    alterarCanalServidor(servidor) {
      if (
        this.selecaoCanais.tipo == "servidor" &&
        this.selecaoCanais.itens[this.canalEdicao]
      ) {
        let arrKeys = Object.keys(this.selecaoCanais.itens);

        for (let indiceKey = 0; indiceKey < arrKeys.length; indiceKey++) {
          this.canais[arrKeys[indiceKey]].servidor = servidor;
        }

        this.selecionarCanalLimpar();
      } else {
        this.canais[this.canalEdicao].servidor = servidor;
      }

      this.$forceUpdate();
    },
    apiFlashphoner() {
      return apiFlashphoner;
    },
    async aoVivo() {
      var apiRequest;
      var body = {};

      if (confirm("Publicar como ao vivo ?")) {
        body.ids = [this.item._id];

        apiRequest = await api.put("/evento/aovivo", body);

        if (apiRequest.data.erro == false) {
          this.item.situacao = 3;
          this.forceRerender();
        }
      }
    },
    async encerrar() {
      var apiRequest;
      var body = {};

      if (confirm("Encerrar evento ?")) {
        body.ids = [this.item._id];

        apiRequest = await api.put("/evento/encerrar", body);

        if (apiRequest.data.erro == false) {
          this.item.situacao = 4;
          this.forceRerender();
        }
      }
    },
    async cliqueCanais(keyCanal, event) {
      if (event.shiftKey) {
        this.definirCanais(keyCanal);
      } else {
        this.abrirEvento(keyCanal);
      }
    },
    async definirCanais(keyCanal) {
      var apiRequest;

      if (parseInt(keyCanal) < 1) {
        return;
      }

      if (confirm("Definir para " + keyCanal + " canais ?")) {
        apiRequest = await api.put("/evento/canais", {
          evento: this.item._id,
          canais: parseInt(keyCanal),
        });

        if (apiRequest.data.erro == false) {
          this.item.canais = parseInt(keyCanal);
          this.forceRerender();
        }
      }
    },
    selecionarCanalLimpar() {
      this.selecaoCanais.tipo = "";
      this.selecaoCanais.primeiro = null;
      this.selecaoCanais.itens = {};
    },
    selecionarCanal(keyCanal, event, tipo) {
      event.preventDefault();

      if (keyCanal == 0 && tipo == "status") {
        return;
      }

      if (this.selecaoCanais.tipo !== tipo) {
        this.selecaoCanais.tipo = tipo;
        this.selecaoCanais.primeiro = parseInt(keyCanal);
        this.selecaoCanais.itens = {};
      }

      if (event.ctrlKey || event.metaKey) {
        if (this.selecaoCanais.itens[keyCanal]) {
          delete this.selecaoCanais.itens[keyCanal];
        } else {
          this.selecaoCanais.itens[keyCanal] = true;
        }
      } else if (event.shiftKey) {
        let arrKeys = Object.keys(this.selecaoCanais.itens);

        if (arrKeys.length == 0) {
          this.selecaoCanais.itens[keyCanal] = true;
        } else {
          let arrSelecaoCanaisTemp = {};

          let indiceInicio = parseInt(this.selecaoCanais.primeiro);
          let indiceFim = parseInt(keyCanal);

          if (indiceInicio <= indiceFim) {
            for (
              let indiceKey = indiceInicio;
              indiceKey <= indiceFim;
              indiceKey++
            ) {
              arrSelecaoCanaisTemp[indiceKey] = true;
            }
          } else {
            for (
              let indiceKey = indiceInicio;
              indiceKey >= indiceFim;
              indiceKey--
            ) {
              arrSelecaoCanaisTemp[indiceKey] = true;
            }
          }

          this.selecaoCanais.itens = arrSelecaoCanaisTemp;
        }
      }

      this.forceRerender();
    },
    forceRerender() {
      this.componentKey += 1;
    }, toggleDropdown(dropdown) {
      this.dropdowns[dropdown] = !this.dropdowns[dropdown];
    },
    selectOption(dropdown, option) {
      if (dropdown === 'video') {
        this.item.dispositivoVideo = option;
      } else if (dropdown === 'audio') {
        this.item.dispositivoAudio = option;
      }
      this.dropdowns[dropdown] = false;
    }
  },
  async mounted() {

    let scriptTailwind = document.createElement("script");
    scriptTailwind.setAttribute(
      "src",
      "https://cdn.tailwindcss.com"
    );
    scriptTailwind.setAttribute("async", true);
    document.head.appendChild(scriptTailwind);

    let scriptFA = document.createElement("link");
    scriptFA.setAttribute(
      "href",
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css"
    );
    scriptFA.setAttribute("rel", "stylesheet");
    document.head.appendChild(scriptFA);

    this.view = this.propView;

    this.carregarItem(this.$route.params.id);

    this.item.dispositivosVideo.push({ id: "screen", nome: "Tela" });

    /*if (this.retornaSite() == "Weddbets") {
      this.item.dispositivosVideo.push({
        id: "sharescreen",
        nome: "Share Screen",
      });
    }*/

    this.item.dispositivosAudio.push({ id: "false", nome: "Sem áudio" });

    try {
      // Solicita permissão ao usuário para acessar mídia (necessário para obter rótulos dos dispositivos)
      await navigator.mediaDevices.getUserMedia({ audio: true, video: true });

      // Obtém a lista de dispositivos disponíveis
      let devicesWebRTC = await navigator.mediaDevices.enumerateDevices();

      // Filtra apenas microfones e webcams
      devicesWebRTC = devicesWebRTC.filter(
        (device) => device.kind === "audioinput" || device.kind === "videoinput"
      );

      for (
        var indiceDevice = 0;
        indiceDevice < devicesWebRTC.length;
        indiceDevice++
      ) {
        var deviceWebRTC = devicesWebRTC[indiceDevice];

        if (deviceWebRTC.kind == "videoinput") {
          this.item.dispositivosVideo.push({
            id: deviceWebRTC.deviceId,
            nome: deviceWebRTC.label,
          });
        }

        if (deviceWebRTC.kind == "audioinput") {
          this.item.dispositivosAudio.push({
            id: deviceWebRTC.deviceId,
            nome:
              deviceWebRTC.deviceId == "default"
                ? "Com áudio (Default)"
                : deviceWebRTC.label,
          });
        }
      }
    } catch (error) {
      console.error("Erro ao obter dispositivos:", error);
    }

    //var openviduDevices = await apiOpenVidu.carregarDevices();
  },
  data: function () {
    return {
      item: {
        _id: "",
        nome: "",
        servidor: "",
        servidorTipo: "",
        rtmpLink: "-",
        rtmpChave: "-",
        linkFonte: "",
        ovToken: "",
        status: false,
        canal: "1",
        canalPrincipal: "",
        canalTransmissao: "",
        cropTopo: "0",
        cropRodape: "0",
        cropEsquerda: "0",
        cropDireita: "0",
        cropTopoLive: "0",
        cropRodapeLive: "0",
        cropEsquerdaLive: "0",
        cropDireitaLive: "0",
        dispositivoVideo: "screen",
        dispositivoAudio: "false",
        dispositivosVideo: [],
        dispositivosAudio: [],
        eventoRemoto: "",
        eventosRemoto: [],
        previewAberto: false,
        abaTransmissaoVideo: "preview",
        tabLive: false,
        publisher: null,
      },
      servidores: {},
      canais: {},
      canalEdicao: "",
      viewPreview: "",
      selecaoCanais: { tipo: "", itens: {} },
      avancado: false,
      componentKey: 1,
      dropdowns: {
        video: false,
        audio: false
      },
    };
  },
  computed: {
    servidoresTipo: function () {
      var arrFiltro = {};
      var arrServidores;
      var thisCall = this;

      if (parseInt(this.canalEdicao) > 0) {
        arrServidores = this.$global
          .servidores_sip_array()
          .filter(function (item) {
            return item.router == false;
          });
      } else {
        arrServidores = this.$global.servidores_sip_array().filter(function () {
          return (
            thisCall.item.servidorTipo == "openvidu" ||
            thisCall.item.servidorTipo == "ms"
          );
        });
      }

      var objServidores = {};

      arrServidores.filter(function (item) {
        objServidores[item.id] = item;
      });

      for (var keyItem in objServidores) {
        if (keyItem.startsWith(this.item.servidorTipo)) {
          arrFiltro[keyItem] = this.$global.servidores_sip()[keyItem];
        }
      }

      return arrFiltro;
    },
    servidoresRouter: function () {
      return this.$global.servidores_sip_array().filter(function (item) {
        return item.router == true;
      });
    },
    servidoresHabilitados: function () {
      return this.$global.servidores_sip_array().filter(function (item) {
        return item.router == false;
      });
    },
    dispositivosAudioObj: function () {
      return util.convertArrayToObject(this.item.dispositivosAudio, "id");
    },
    dispositivosVideoObj: function () {
      return util.convertArrayToObject(this.item.dispositivosVideo, "id");
    },
  },
};
</script>

<style>
#app {
  margin-top: 10px;
}

.dropdown-content {
  position: absolute;
  background-color: #f9f9f9;
  min-width: 100%;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  border-radius: 8px;
  margin-top: 8px;
}

.dropdown-content div {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  cursor: pointer;
  border-radius: 4px;
}

.dropdown-content div:hover {
  background-color: #f1f1f1;
}

.dropdown-button span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>